var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app"},[_c('CWrapper',[(_vm.$route.meta.showHeader)?_c('NavigationBar'):_vm._e(),_c('div',{staticStyle:{"background-color":"#FFFFFF"}},[_c('main',{staticClass:"c-main",staticStyle:{"padding-top":"0px"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{class:[
            'page',
            _vm.$route.meta.showHeader ? null : 'no-header'
            ]})],1)],1)]),(_vm.$route.meta.showFooter)?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }